import { useRequest, useView } from '@10000/react'
import { InputScreen, onboardBackground, useBackground, useShell, useStack } from '../../layout'
import { Box } from '../../widgets'
import { SelectableList } from '../../forms'
import { Teams } from './'
import { OnboardConfirmation } from '../teamLead'
import { roles } from '../../../lookups'

export const TeamRole = ({ active, id, organisationId }) => {
  const request = useRequest('tenant')
  const { push } = useStack()
  const { teams, user: { admin } } = useView('tenant')
  const { role } = teams.find(x => x.id === id) || {}

  useShell({ active, mode: 'navigate narrow' })
  useBackground().set(mobile => ({ active, fade: !admin, ...onboardBackground(admin, mobile) }))

  const selectRole = ({ role }) => {
    if(role !== undefined) {
      return request('teamUpdated', { id, role }).then(() => push(admin ? Teams : OnboardConfirmation, { props: { organisationId } }))
    }
  }

  return (
    <InputScreen
      fade
      fadeColour={!admin && 'blue'}
      onSubmit={selectRole}
      formValues={{ role }}
      footerButton="Next"
      title="Type of team"
      description="Within your organisation, what function does your team fulfil, or what &quot;department&quot; are you in?"
      minHeight={0}
    >
      <Box overflow="auto" py={8}>
        <SelectableList name="role" list={roles.map(({ name }) => name)}/>
      </Box>
    </InputScreen>
  )
}